import produce from "immer";
import Action from "./Action";
import { BillingContext } from "../../Models/Billing/BillingContext";
import BillingAction from "../../Models/Billing/BillingAction";
import { sessionStorageKey } from "../../Config/Constants";
import defaultState from "./defaultState";
import { billingActionEnum } from "../../Config/BillingType";

const BillingReducer = (state: BillingContext, action: BillingAction) => {
  const newState = produce(state, (draft) => {
    switch (action.type) {
      case billingActionEnum.RESET:
        draft = defaultState;
        break;
      case billingActionEnum.CONFIRMATION:
        const { orderId } = action.payload;
        draft.orderId = orderId;
        break;
      case billingActionEnum.SKU_DETAILS:
        const {
          skuGuid,
          skuSubCategory,
          unitPrice,
          recurringPrice,
          scheduleTypeCD,
          currencyCD,
          currencySymbol,
          description,
          label,
        } = action.payload;
        draft.skuGuid = skuGuid;
        draft.skuSubCategory = skuSubCategory;
        draft.unitPrice = unitPrice;
        draft.recurringPrice = recurringPrice;
        draft.skulabel = label;
        draft.scheduleTypeCD = scheduleTypeCD;
        draft.currencySymbol = currencySymbol;
        break;
      default:
        throw new Error("Action Type Not Define");
    }
  });
  /* SAVE IN SESSION STORAGE */
  sessionStorage.setItem(sessionStorageKey.BILLING_STATE, JSON.stringify(newState));
  return newState;
};

export default BillingReducer;
